import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sd-app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    const token = this.getQueryStringValue('token');
    if (token) {
      sessionStorage.clear();
      sessionStorage.setItem('crmToken', token);
    }
    const tradingID = this.getQueryStringValue('trading_id');
    if (tradingID) {
      sessionStorage.setItem('B_CRM_ACCOUNT', tradingID);
    }
    const lang = this.getQueryStringValue('lang');
    if (lang && ['en', 'zh', 'jp'].includes(lang)) {
      localStorage.setItem('lanGuage', lang);
    }
  }
  getQueryStringValue (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
  }
  title = 'app';
}
